import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { Dealer, DealerStatus } from '../data/dealer';

@Injectable({
  providedIn: 'root',
})
export class DealerService {
  private dealerUrl = `${environment.apiUrl}/api/Dealers`;

  constructor(private http: HttpClient) { }

  getDealers(): Observable<Dealer[]> {
    const url = `${this.dealerUrl}/`;
    return this.http.get<Dealer[]>(url)
      .pipe(
        tap(_ => this.log('fetched dealers')),
        catchError(this.handleError<Dealer[]>('getDealers'))
      );
  }

  getDealer(pa_code: string): Observable<Dealer> {
    const url = `${this.dealerUrl}/FCT${pa_code}`;
    return this.http.get<Dealer>(url)
      .pipe(
        tap(_ => this.log('fetched dealers')),
        catchError(this.handleError<Dealer>('getDealer'))
      );
  }

  getFleetDealer(pa_code: string): Observable<Dealer> {
    const url = `${this.dealerUrl}/FIN${pa_code}`;
    return this.http.get<Dealer>(url)
      .pipe(
        tap(_ => this.log('fetched fleet dealer')),
        catchError(this.handleError<Dealer>('getFleetDealer'))
      );
  }

  getSingleDealerStatus(pa_code: string): Observable<DealerStatus> {
    const url = `${this.dealerUrl}/dealer-status/${pa_code}`;
    return this.http.get<DealerStatus>(url)
      .pipe(
        tap(_ => this.log('fetched dealers')),
        catchError(this.handleError<DealerStatus>('getSingleDealerStatus'))
      );
  }

  getStatus(username: string): Observable<DealerStatus[]> {
    const url = `${this.dealerUrl}/status`;
    return this.http.get<DealerStatus[]>(url)
      .pipe(
        tap(_ => this.log('fetched dealer statuses')),
        catchError(this.handleError<DealerStatus[]>('getStatus'))
      );
  }

  getDealerStatus(username: string): Observable<DealerStatus[]> {
    const url = `${this.dealerUrl}/dealer-status?username=${username}`;
    return this.http.get<DealerStatus[]>(url)
      .pipe(
        tap(_ => this.log('fetched dealer statuses')),
        catchError(this.handleError<DealerStatus[]>('getDealerStatus'))
      );
  }

  getFleetStatus(username: string): Observable<DealerStatus[]> {
    const url = `${this.dealerUrl}/fleet-status`;
    return this.http.get<DealerStatus[]>(url)
      .pipe(
        tap(_ => this.log('fetched fleet statuses')),
        catchError(this.handleError<DealerStatus[]>('getFleetStatus'))
      );
  }

  getRep(username: string, role: string): Observable<Dealer[]> {
    const url = `${this.dealerUrl}/status`;
    return this.http.get<Dealer[]>(url)
      .pipe(
        tap(_ => this.log('fetched dealers for rep')),
        catchError(this.handleError<Dealer[]>('getRep'))
      );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  private log(message: string) {
    console.log(message);
  }
}